import React from "react";
import "./App.css";
import Main from "./Main";

const App = () => {
  return (
    <div className="app">
      <Main />
    </div>
  );
};

export default App;
